import React, { useEffect, useState } from "react";
import { getWithoutTokenAPI } from "../../util/Api";
import freshFruit from "../../assets/Images/Categories/image1.png";
import freshVegetables from "../../assets/Images/Categories/image2.png";
import meatFish from "../../assets/Images/Categories/image3.png";
import snacks from "../../assets/Images/Categories/image4.png";
import beverages from "../../assets/Images/Categories/image5.png";
import beautyHealth from "../../assets/Images/Categories/image6.png";
import breadBakery from "../../assets/Images/Categories/image7.png";
import bakingNeeds from "../../assets/Images/Categories/image8.png";
import cooking from "../../assets/Images/Categories/image9.png";
import diabeticFood from "../../assets/Images/Categories/image10.png";
import dishDetergents from "../../assets/Images/Categories/image11.png";
import oil from "../../assets/Images/Categories/image12.png";
import { useNavigate } from "react-router-dom";


const Allcategories = () => {
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [error, seterror] = useState(null)
    const [loading, setloading] = useState(true)
    const localCategoryImages = {
        "Fresh Fruit": freshFruit,
        "Fresh Vegetables": freshVegetables,
        "Meat & Fish": meatFish,
        "Snacks": snacks,
        "Beverages": beverages,
        "Beauty & Health": beautyHealth,
        "Bread & Bakery": breadBakery,
        "Baking Needs": bakingNeeds,
        "Cooking": cooking,
        "Diabetic Food": diabeticFood,
        "Dish Detergents": dishDetergents,
        "Oil": oil,
    };

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const result = await getWithoutTokenAPI("/category/find-all?Approval_status=Approval");
                if (result && !result.error && result.data?.categories) {
                    const dataWithImages = result.data.categories.map((cat) => ({
                        id: cat._id,
                        name: cat.category_name,
                        image: cat.image || localCategoryImages[cat.category_name] || "",
                        seller: cat.created_by?.name || "Unknown", // Get seller name 

                    }));
                    setCategories(dataWithImages);
                } else {
                    seterror("Failed to load categories", result.error || "Invalid response format");
                }
            }
            finally { setloading(false) }
        };
        fetchCategories();
    }, []);

    const handleCategoryClick = (category) => {
        navigate(
            `/shop?category_id=${category.id}&category_name=${encodeURIComponent(category.name)}`,
            {
                state: {
                    selectedCategoryId: category.id,
                    selectedCategoryName: category.name
                },
            }
        );
    };

    return (
        <div className="container-fluid my-5">
            <h6 className="text-center ff-poppins fs-14 fw-500 fc-green category-title d-flex justify-content-center">CATEGORY</h6>
            <h2 className="text-center ff-poppins fs-36 fw-600 category-title-2">Shop by Top Categories</h2>
            {
                loading ? (
                    <div className="text-center text-success">
                        <p>Loading Categories... !</p>
                    </div>
                ) : !!error ? <div className="text-center text-danger">
                    <p>{error}</p>
                </div> : (
                    <div className="row mt-4">
                        <div className="categories-wrapper">
                            {categories.map((category, index) => (
                                <div
                                    key={index}
                                    className="category-col"
                                >
                                    <div
                                        className="category-box text-center"
                                        onClick={() => handleCategoryClick(category)}
                                    >
                                        <img
                                            src={category.image}
                                            alt={category.name}
                                            className="img-fluid mb-2 category-image "
                                        />
                                        <p className="ff-poppins fw-500 fs-13 category-box-category-name mb-0">
                                            {category.name}
                                        </p>
                                    </div>

                                </div>
                            ))}
                        </div>
                    </div >
                )
            }

        </div >
    )
}

export default Allcategories